"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReschedulingLink = void 0;
const types_1 = require("@lemonone/types");
function createReschedulingLink({ orderUuid }) {
    const url = new URL(types_1.ensureEnv('BOOKING_APP_URL'));
    url.pathname = '/reschedule';
    url.searchParams.set('id', orderUuid);
    return url.toString();
}
exports.createReschedulingLink = createReschedulingLink;
//# sourceMappingURL=createReschedulingLink.js.map